import { QueryParameters as GetCartQueryParams } from "@faire/web-api--source/endpoints/www/api/v2/carts/cartToken/get";
import { BrandCartsSortBy } from "@faire/web-api--source/faire/carts/BrandCartsSortBy";
import { useCallback } from "react";

import { useFilterKeys } from "./useFilterKeys";

const VISIBLE_WINDOW_SIZE = 8;
export const SUBSEQUENT_PAGE_SIZE = 20;
export const INITIAL_PAGE_SIZE = SUBSEQUENT_PAGE_SIZE + VISIBLE_WINDOW_SIZE;

type BuildQueryParamsArg = {
  savedForLater: boolean;
  hasFbfBenefits: boolean;
  cursor?: string;
  query?: string;
};

export const useCartQueryParams = () => {
  const filterKeys = useFilterKeys();
  return useCallback(
    ({ savedForLater, hasFbfBenefits, cursor, query }: BuildQueryParamsArg) => {
      const max_results = cursor ? SUBSEQUENT_PAGE_SIZE : INITIAL_PAGE_SIZE;
      return GetCartQueryParams.build({
        filter_brand_carts_by_keys: filterKeys ?? [],
        saved_for_later: savedForLater,
        // even when has_fbf_benefits is false value will throw a 400, if the retailer is in FULFILLED_BY_FAIRE_RETAILER_EXPERIENCE_250710 control
        has_fbf_benefits: hasFbfBenefits || undefined,
        brand_tokens: [],
        exclude_alcohol_disclaimer: false,
        sort_brand_carts_by: BrandCartsSortBy.UPDATED_AT,
        cursor,
        query,
        max_results,
      });
    },
    [filterKeys]
  );
};
